export enum BaseInsightFilterContentType {
    INSIGHTS = "Insights",
}

export enum PlmInsightFilterContentType {
    PITCHED_CONTENT = "Pitched Content",
}

export type YourInsightFilterContentType =
    | BaseInsightFilterContentType
    | PlmInsightFilterContentType;
export const YourInsightFilterContentType = {
    ...BaseInsightFilterContentType,
    ...PlmInsightFilterContentType,
};

export enum YourInsightFilterContentSubType {
    PACKAGED_INSIGHTS = "PKG",
    WORKBENCH_INSIGHTS = "WB",
}

export const PLM_ALLOWLISTED_ROLES = ["acc-account-team-users", "cms-admins"];

export interface YourInsightFilterState {
    contentType: YourInsightFilterContentType;
    contentSubType?: YourInsightFilterContentSubType;
    filters: YourInsightsFilters;
}

export const defaultYourInsightFilterState = {
    [YourInsightFilterContentType.INSIGHTS]: {
        contentSubType: YourInsightFilterContentSubType.PACKAGED_INSIGHTS,
    },
    [YourInsightFilterContentType.PITCHED_CONTENT]: {
        contentSubType: undefined,
    },
};

export interface YourInsightsFilters {
    // TODO: Update when filters are supported for your insight decks
}

export const YourInsightFilterTypeMappings: Record<
    YourInsightFilterContentType,
    YourInsightFilterContentSubType[]
> = {
    [YourInsightFilterContentType.INSIGHTS]: [
        YourInsightFilterContentSubType.PACKAGED_INSIGHTS,
        YourInsightFilterContentSubType.WORKBENCH_INSIGHTS,
    ],
    [YourInsightFilterContentType.PITCHED_CONTENT]: [],
};
